import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { TrackerService } from '../../../services/tracker.service';
import * as _ from 'lodash';

@Component({
  selector: 'ti-summary-bar',
  template: require('./trackeritem.summary-bar.component.html')
})
export class SummaryBarComponent implements OnInit, OnChanges {
  @Input() trackeritem: any;
  @Input() tracker: any;
  @Input() assignees: any;
  @Input() acls: any;
  @Input() errors: any;

  members: any[] = [];
  assigneesSelectorOptions: any;
  showAssignees: boolean = false;
  priorityOptions: any = {};
  waitingForOptions: any = {};
  storyPointsOptions: any = {};
  statusField: any;
  showCloseDate: any;

  constructor(
    private trackerService: TrackerService, 
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.initialize();
  }

  ngOnChanges() {
    this.statusField = this.getStatusField();
  }

  initialize() {
    this.members = [];
    this.showAssignees = false;

    this.priorityOptions = {
      id: 'priority',
      fieldName: this.translateService.translate('Priority'),
      fieldElements: this.trackerService.fields.builtIn.priority.getList()
    };

    this.waitingForOptions = {
      id: 'waiting_for',
      fieldName: this.translateService.translate('Waiting For'),
      fieldElements: this.trackerService.fields.builtIn.waiting_for.getList()
    };

    this.trackerService.getMembers(this.tracker.id)
      .then((members) => {
        this.members = members;
      })
      .catch(() => {
        this.members = [];
      })
      .then(() => {
        this.showAssignees = true;
      });

    this.storyPointsOptions = {
      id: 'story_points',
      fieldName: this.translateService.translate('Story Points'),
      fieldElements: this.trackerService.fields.builtIn.story_points.getStoryPointsOptionsList(this.tracker?.fields?.storyPoints?.fieldElements)
    };

    this.showCloseDate = (_.get(this.trackeritem, 'statusId', -1) == 0);
  }

  getStatusField() {
    let fld = _.cloneDeep(_.get(this.tracker, 'fields.status', {}));
    const id = _.get(this.trackeritem, 'extraFields.status.fieldData.id', 0);
    let elements = this.trackerService.workflow.getFieldElementsByWorkflow(this.tracker, 'status', id);
    if (id && !_.find(elements, { id: id })) {
      const elem = _.find(_.get(this.tracker, 'fields.status.fieldElements', []), { id: id});
      if (elem) {
        elements.push(elem);
      }
    }
    fld.fieldElements = _.sortBy(elements, 'sortOrder');
    return fld;
  }

  /**
   * Return true if the given member is the submitter of this tracker item, false otherwise
   * @param {object} member
   * @returns {boolean}
   */
   public isSubmittedBy(member) {
    return (
      _.get(this.trackeritem, 'submittedBy.id', -1) == _.get(member, 'id', -2)
    );
   }

  setSubmitter(member: any) {
    this.trackeritem.submittedBy = member;
  }

  onSubmitterSelected(selectedMembers: any[]) {
    // For single selection, take the first (and only) selected member
    if (selectedMembers && selectedMembers.length > 0) {
      this.setSubmitter(selectedMembers[0]);
    }
  }

  handleFieldDataChange($event: any, fieldId: string) {
    switch (fieldId) {
      case 'priority':
        this.trackeritem.priority = $event;
        break;
      case 'status':
        this.trackeritem.extraFields.status.fieldData = $event;
        break;
      case 'waitingFor':
        this.trackeritem.waitingFor = $event;
        break;
      case 'storyPoints':
        this.trackeritem.storyPoints = $event;
        break;
    }
  }
}
